import { render } from "./LoadingSpinner.vue?vue&type=template&id=28d1ced7&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=28d1ced7&scoped=true&lang=css"

import exportComponent from "../../../../../client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d1ced7"],['__file',"views/order/assets/components/bookHoouse/LoadingSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28d1ced7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28d1ced7', __exports__)) {
    api.reload('28d1ced7', __exports__)
  }
  
  module.hot.accept("./LoadingSpinner.vue?vue&type=template&id=28d1ced7&scoped=true", () => {
    api.rerender('28d1ced7', render)
  })

}


export default __exports__